import { render, staticRenderFns } from "./CostCenterPage.vue?vue&type=template&id=0bad37a8&"
import script from "./CostCenterPage.vue?vue&type=script&lang=js&"
export * from "./CostCenterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports